<template>
  <div class="row scroll no-wrap">
    <div
      v-for="option in $Constants.LEASE_TERM_OPTIONS"
      :key="option.value"
      class="q-mr-sm col"
    >
      <SAICardToggle
        :error="error"
        :disable="disable"
        class="q-py-md q-px-lg"
        :active="option.value === value"
        @click="$emit('input', option.value)"
      >
        <p class="text-weight-medium text-no-wrap text-center">
          {{ option.label }}
        </p>
      </SAICardToggle>
    </div>
  </div>
</template>

<script>
import { SAICardToggle } from 'ecx.saigon.ui.common';

export default {
  name: 'LeaseTermSelect',
  props: {
    disable: Boolean,
    value: undefined,
    error: Boolean,
  },
  components: {
    SAICardToggle
  }
};
</script>
